module.exports = "<selectize config='config' options='models' ng-model=\"_model\"></selectize>"


/*****************
 ** WEBPACK FOOTER
 ** ./components/formly/ref.select.html
 ** module id = 24
 ** module chunks = 0
 **/